module.exports = __webpack_public_path__ + "img/pgs-0-10.7a164d77.png";